module.exports = __webpack_public_path__ + "static/media/imgbase-1.39659dc5.png";